import styled from '@emotion/styled';
import { greens, greys, white } from '@/styles/colors';
import { sansSerif } from '@/styles/typography';

// Figma: Corporate Account — Discovery, "Their uploads & tags". Tags render as outlined pills
// rather than a stack of form rows; everything the old rows could do moved into the editor
// modal a pill opens.

export const Section = styled.div`
    ${sansSerif}
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const SectionHeader = styled.div`
    align-items: center;
    display: flex;
    gap: 10px;
`;

export const AccentBar = styled.span`
    background: ${greens.primary};
    border-radius: 2px;
    height: 18px;
    width: 4px;
`;

export const SectionTitle = styled.span`
    color: #0c0b1d;
    font-size: 15px;
    font-weight: 700;
`;

export const SectionNote = styled.span`
    color: ${greys.subtitle};
    font-size: 13px;
`;

export const HeaderActions = styled.div`
    align-items: center;
    display: flex;
    gap: 8px;
    margin-left: auto;
`;

export const PillRow = styled.div`
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
`;

export const TagPill = styled.button`
    ${sansSerif}
    align-items: center;
    background: ${white.primary};
    border: 1px solid ${greys.border};
    border-radius: 16px;
    color: ${greys.secondary};
    cursor: pointer;
    display: inline-flex;
    font-size: 13px;
    gap: 8px;
    height: 31px;
    padding: 0 14px;

    &:hover {
        border-color: ${greys.primary};
    }

    &:disabled {
        cursor: default;
        opacity: 0.6;
    }
`;

// Unsaved edits are worth surfacing on the pill itself — the save is explicit and batched, so
// the only other signal is the Save button.
export const DirtyDot = styled.span`
    background: ${greens.primary};
    border-radius: 50%;
    height: 6px;
    width: 6px;
`;

export const TypeCount = styled.span`
    color: ${greys.subtitle};
    font-size: 12px;
`;

export const AddPill = styled(TagPill)`
    border-style: dashed;
    color: ${greys.subtitle};
`;

// Org-owned tags are managed on the CorporateTags page; here they are display only.
export const ReadOnlyPill = styled.span`
    ${sansSerif}
    align-items: center;
    background: ${white.secondary};
    border: 1px solid ${greys.border};
    border-radius: 16px;
    color: ${greys.primary};
    display: inline-flex;
    font-size: 13px;
    gap: 8px;
    height: 31px;
    padding: 0 14px;
`;

export const EmptyNote = styled.span`
    color: ${greys.subtitle};
    font-size: 13px;
`;

export const Field = styled.div`
    margin-bottom: 1.25rem;
`;

export const FieldLabel = styled.span`
    color: ${greys.secondary};
    display: block;
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 0.5rem;
`;

export const DangerRow = styled.div`
    border-top: 1px solid ${greys.border};
    display: flex;
    justify-content: flex-start;
    margin-top: 1.5rem;
    padding-top: 1rem;
`;
